module.exports = "<ui-view>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-updates.html
// module id = 1125
// module chunks = 0